import { type FC, type HTMLAttributes, useContext } from 'react';
import cn from 'classnames';
import { motion } from 'framer-motion';

import { DiceGameContext } from '../context';

import { DiceFace } from './DiceFace';

import css from './styles.module.scss';

interface DiceAnimationProps extends HTMLAttributes<HTMLDivElement> {
  result: 1 | 2 | 3 | 4 | 5 | 6;
}

const DiceAnimation: FC<DiceAnimationProps> = ({ result, ...props }) => {
  const {
    dice: { scope: diceScope },
  } = useContext(DiceGameContext);

  const diceFaceConfigArray: {
    id: string;
    className: string;
    dotQuantity: number;
    positionArray: string[];
  }[] = [
    {
      id: 'front',
      className: css.front,
      dotQuantity: 1,
      positionArray: ['a5'],
    },
    {
      id: 'back',
      className: css.back,
      dotQuantity: 6,
      positionArray: ['a1', 'a4', 'a7', 'a3', 'a6', 'a9'],
    },
    {
      id: 'top',
      className: css.top,
      dotQuantity: 2,
      positionArray: ['a1', 'a9'],
    },
    {
      id: 'bottom',
      className: css.bottom,
      dotQuantity: 5,
      positionArray: ['a1', 'a3', 'a5', 'a7', 'a9'],
    },
    {
      id: 'right',
      className: css.right,
      dotQuantity: 4,
      positionArray: ['a1', 'a3', 'a7', 'a9'],
    },
    {
      id: 'left',
      className: css.left,
      dotQuantity: 3,
      positionArray: ['a1', 'a5', 'a9'],
    },
  ];

  return (
    <div {...props} className={cn(css.diceWrapper, props.className)}>
      <motion.div ref={diceScope} className={css.dice}>
        {diceFaceConfigArray.map(({ id, ...props }) => (
          <DiceFace key={id} {...props} />
        ))}
      </motion.div>
    </div>
  );
};

export { DiceAnimation };
